module.exports = __webpack_public_path__ + "static/img/gpt25.fee0bcda.png";